// Lightweight analytics — logs to console for now.
// Swap with a real analytics service later.
const isDev = process.env.NODE_ENV === 'development';

export const track = (event, data = {}) => {
  if (isDev) {
    console.log(`[analytics] ${event}`, data);
  }
  // TODO: POST to /analytics/event when backend endpoint exists
};

export const getFormat = (width, height) => {
  if (!width || !height) return 'unknown';
  const ratio = width / height;
  if (ratio > 1.1) return 'landscape';
  if (ratio < 0.9) return 'portrait';
  return 'square';
};
